<template>
<div class="ammeter">
  <ProjectLogin class="s-header"></ProjectLogin>
  <div class="wrap">
    <div class="title">
      <span class="x-btn">
        <el-button type="text" style="color:#76defc;font-weight: bold;" icon="el-icon-back" @click="$router.back(-1)">返回</el-button>
        <span class="crumb">项目接线图</span>
        <span class="current-crumb"> >{{ buttonName }}</span>
        <span class="point-status">
          <span>通信状态：</span>
          <span>
            <span class="green"></span>
            <span>连接</span>
          </span>
          <span>
            <span class="red"></span>
            <span>断开</span>
          </span>
        </span>
      </span>
    </div>
    <div class="tabs">
      <span class="a-block" :class="{ active: activeId == item.id }" v-for="(item, index) in tabIds" :key="index" @click="switchTab(item)">{{ item.tabContent }}</span>
    </div>
    <div class="small-tabs">
      <p class="tb" v-for="(item, index) in nameList" :key="index" @click="setActiveItem(item)">
        <span class="name" :class="{ ac: nameIndex == item.id }">{{ item.name }}</span>
        <span class="separator" v-if="index < nameList.length-1">|</span>
      </p>
    </div>
    <div class="w-container">
      <el-carousel indicator-position="outside" trigger="click" ref="carousel" @change="changeItem" :autoplay="false">
        <el-carousel-item v-for="(item, index) in wiringDiagramData" :key="index">
          <div style="width: 100%;height: 70vh;padding-top: 80px; overflow: auto;">
            <child-canvas ref="mc" :canvasWidth="item.canvasWidth" :canvasHeight="item.canvasHeight" :itemData="[item]" :mainCanvasId="'mainCanvas' + index" :canvasId="'canvasId' + index" :tabId="activeId" @complete="completeCanvasLoad" @toUrl="toUrl" :projectId="projectId"></child-canvas>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</div>
</template>

<script>
import childCanvas from '@/components/childCanvas';
import {
  Loading
} from 'element-ui';
import API from '@/api/svolt/wiring-diagram.js';
import T from '@/utils/tools.js';
import ProjectLogin from '@/views/svolt/project/components/nanwang/header';
import testData from './test.json';
export default {
  name: 'ammeter',
  components: {
    ProjectLogin,
    'child-canvas': childCanvas
  },
  data() {
    return {
      projectId: '',
      tabIds: [],
      activeId: '',
      buttonName: '', //当前按钮名称
      nameList: [],
      nameIndex: 0,
      loadingInstance: '',

      options: {
        // loding拓扑图加载
        lock: true,
        text: '正在加载',
        spinner: 'el-icon-loading lodings',
        background: 'rgba(0, 0, 0, 0.7)'
      },
      wiringDiagramData: [] //接线图数据
    };
  },
  methods: {
    changeItem(e) {
      this.nameIndex = e;
    },
    //设置选中节点
    setActiveItem(item) {
      this.nameIndex = item.id;
      this.$refs.carousel.setActiveItem(item.id);
    },
    //获取接线图标签
    async primaryWiringDiagramTab(tabType) {
      this.loadingInstance = Loading.service(this.options);
      let params = {
        projectId: this.projectId,
        tabType: tabType
      };
      let res = await API.primaryWiringDiagramTab(params);
      if (res.data.code == 200) {
        this.tabIds = res.data.data;
        if (this.tabIds.length) {
          this.activeId = this.tabIds[0].id;
          this.buttonName = this.tabIds[0].tabContent;
        }
        this.wiringDiagram(this.tabIds[0].id);
      }
    },
    //获取接线图
    async wiringDiagram(tabId) {
      let self = this;
      let params = {
        projectId: this.projectId,
        tabId: tabId
      };
      let res = await API.wiringDiagram(params);
      if (res.data.code == 200) {
        let tmpData = res.data.data;
        let offset = 400;
        tmpData.map(item => {
          item.canvasWidth = T.getLeafWidth([item]) + offset;
          item.canvasHeight = T.getTreeHeight([item]);
        });
        if (res.data.data.length) {
          this.nameList = [];
          res.data.data.forEach((item, index) => {
            this.nameList.push({
              id: index,
              name: item.name
            });
          });
          this.nameIndex = this.nameIndex ? this.nameIndex : 0;
        }
        this.wiringDiagramData = res.data.data;
        // this.wiringDiagramData = testData;
        this.completeCanvasLoad();
      }
    },
    //切换页签
    switchTab(item) {
      this.activeId = item.id;
      this.buttonName = item.tabContent;
      this.wiringDiagram(this.activeId);
    },
    //跳转
    toUrl(item) {
      let path = item.url.href;
      let query = item.url.param;
      this.$router.push({
        path: path,
        query: query
      });
    },
    //完成画布的加载
    completeCanvasLoad() {
      this.closeLoading(this.loadingInstance);
    },
    closeLoading(loadingInstance) {
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      });
    }
  },
  mounted() {
    let self = this;
    this.projectId = this.$route.query.projectId;
    this.primaryWiringDiagramTab(244);
    this.interval = setInterval(function () {
      if (self.activeId) {
        self.wiringDiagram(self.activeId);
      }
    }, 20000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.ammeter {
  width: 100%;
  height: 100%;
  // background: #000;
  // background: url('/static/images/svolt/project-bj-01.png');
  // background-size: 100% 100%;
  overflow-x: hidden;
  // position: absolute;
  z-index: 10;

  .s-header {
    position: absolute;
  }

  .wrap {
    background: #000;
    height: calc(100% - 58px);
    margin-top: 58px;
    padding: 10px 20px 20px 20px;

    .title {
      position: relative;
      color: #ffffff;
    }

    .crumb {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 600;
      color: #71daf9;
      margin-left: 5px;
    }

    .current-crumb {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 400;
      color: #71daf9;
    }

    .small-tabs {
      height: 40px;
      line-height: 40px;
      width: 100%;
      border-bottom: 1px solid #15325f;

      .tb {
        position: relative;
        display: inline-block;
      }

      .name {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #9ba0b3;
        display: inline-block;
        margin: 0px 10px;
        box-sizing: border-box;

        &:hover {
          cursor: pointer;
          color: #389bc7;
          border-bottom: 1px solid #389bc7;
        }
      }

      .separator {
        position: relative;
        color: #389ac7;
        // left: 10px;
      }

      .ac {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #389bc7;
        border-bottom: 1px solid #389bc7;
      }
    }

    .tabs {
      padding: 10px 0px;

      .a-block {
        display: inline-block;
        padding: 10px 20px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        color: #999999;
        font-weight: bold;
        text-align: center;
        background-color: #15325f;
        margin-right: 10px;

        &:hover {
          cursor: pointer;
          color: #ffffff;
          background-color: #389ac7;
        }
      }

      .active {
        color: #ffffff;
        background-color: #389ac7;
      }
    }

    .w-container {
      overflow: auto;
      height: 75vh;

      .el-carousel {
        >>>.el-carousel__container {
          height: 70vh !important;
        }
      }
    }

    .point-status {
      position: absolute;
      right: 100px;
      top: 0px;

      .green {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background-color: #00fed5;
        margin-top: 4px;
        margin-right: 2px;
      }

      .red {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background-color: #ff373b;
        margin-top: 4px;
        margin-right: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/wiring-diagram/ammeter.vue